/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Dashboard_Recentactivity_Projectapproved2Inputs */

const he_dashboard_recentactivity_projectapproved2 = /** @type {(inputs: Dashboard_Recentactivity_Projectapproved2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`פרויקט "${i?.name}" אושר`)
};

const en_dashboard_recentactivity_projectapproved2 = /** @type {(inputs: Dashboard_Recentactivity_Projectapproved2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Project "${i?.name}" approved`)
};

/**
* | output |
* | --- |
* | "Project \"{name}\" approved" |
*
* @param {Dashboard_Recentactivity_Projectapproved2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const dashboard_recentactivity_projectapproved2 = /** @type {((inputs: Dashboard_Recentactivity_Projectapproved2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Recentactivity_Projectapproved2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_dashboard_recentactivity_projectapproved2(inputs)
	return en_dashboard_recentactivity_projectapproved2(inputs)
});
export { dashboard_recentactivity_projectapproved2 as "dashboard_recentActivity_projectApproved" }